<template>
  <section id="BARRING_RESELLING_STATUS">
    <transition name="fade" mode="out-in" appear>
      <VSpinner v-if="isLoading" class="offset-top-2" />
      <div v-else class="offset-top-2">
        <div v-if="isSuccess" class="container-fixed notification notification-dismissible notification-positive">
          <button type="button" class="close" @click="isSuccess = false">
            <VSvgIcon name="cancel" variant="outlined" />
            <span class="sr-only">{{ $t('common.close') }}</span>
          </button>
          <div class="notification-left">
            <div class="icon-frame">
              <VSvgIcon name="confirm" variant="outlined" size="large" />
            </div>
          </div>
          <div class="notification-content">
            <div class="notification-heading offset-top-1">
              {{ $t('barring.noticeSaveSuccessful') }}
            </div>
          </div>
        </div>

        <div class="offset-top-2">
          <div class="container-fixed offset-top-2">
            <VButton
              v-if="isBarringShowHistoryAllowed"
              label="barring.show_reselling_profile_versions"
              class="btn-brand offset-bottom-2"
              :to="{ name: BARRING_RESELLING_HISTORY }"
            />

            <div v-html="$t('barring.statusInfotextReselling')" />
          </div>

          <div class="container-fixed offset-bottom-3">
            <section role="list" class="offset-top-2 offset-bottom-3">
              <VStatus role="listitem" type="reselling" :is-barred="isResellingBarred" :items="resellingItems" />
            </section>

            <div class="pull-left offset-left-1 button-bar">
              <VButton
                id="editBarringProfile"
                data-test="edit"
                label="barring.editBarringProfileReselling"
                class="btn-brand"
                :disabled="isBlocked"
                @click="onEdit"
              />
              <label class="offset-left-1" for="editBarringProfile">
                <template v-if="isBlocked">
                  {{ $t('barring.profileBlocked') }}
                </template>
                <template v-else>
                  {{ $t('barring.buttonAdjacentTextTypePartner') }}
                </template>
              </label>
            </div>
            <p class="clearfix"></p>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import emitter from '@/plugins/emitter';
import { BARRING_RESELLING_EDIT, BARRING_RESELLING_HISTORY, ERROR } from '@route-types';
import TitleMixin from '@/mixins/title';
import BarringStatusMixin from '@/mixins/barringStatus';
import Proxy from '@/proxies/BarringProfileResellingProxy';
import VButton from '@/components/Button';
import VSpinner from '@/components/Spinner';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
const BASE = process.env.BASE_URL || '/';
export default {
  name: 'BarringResellingStatus',

  components: {
    VSvgIcon,
    VSpinner,
    VButton,
  },

  mixins: [TitleMixin, BarringStatusMixin],

  props: {
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      BARRING_RESELLING_HISTORY,
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters('system', ['isBarringShowHistoryAllowed']),
  },

  async created() {
    await this.load();
    emitter.on('navigationReload', this.onReload);
  },

  beforeDestroy() {
    emitter.off('navigationReload', this.onReload);
  },

  methods: {
    async load() {
      try {
        const response = await new Proxy().status();

        this.parseResponse(response);

        this.isLoading = false;
      } catch (error) {
        /**
         * has to be catched, because this is also triggered by emitter!
         * (where errorHandler doesn't work)
         */

        this.$router.push({ name: ERROR, params: { error } });
      }
    },

    async onReload() {
      this.isLoading = true;
      await this.load();
    },

    onEdit() {
      this.$router.push({ name: BARRING_RESELLING_EDIT });
    },
  },
};
</script>
